import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { axiosInstance } from '../helpers'

export type VendorComplianceStatus =
    | 'COMPLIANT'
    | 'NON_COMPLIANT'
    | 'EXPIRED'
    | 'EXPIRING_SOON'
    | 'PENDING_REVIEW'
    | 'NO_COI'

export interface ComplianceStats {
    total_vendors: number
    compliant: number
    action_required: number
    expiring_soon: number
}

export interface VendorCompliance {
    vendor_id: number
    vendor_name: string
    services: string[]
    status: VendorComplianceStatus
    coi_count: number
    expiring_soon_count: number
    earliest_expiration: string | null
    compliance_issues: string[]
}

export interface ComplianceDashboardResponse {
    stats: ComplianceStats
    vendors: VendorCompliance[]
}

const QUERY_KEY = ['complianceDashboard']

export const useComplianceDashboard = () => {
    const { data: dashboardData, isLoading, error, refetch } = useQuery<
        AxiosResponse<ComplianceDashboardResponse>,
        Error
    >({
        queryKey: QUERY_KEY,
        queryFn: () => axiosInstance.get('/company/compliance-dashboard/'),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })

    return {
        stats: dashboardData?.data?.stats || null,
        vendors: dashboardData?.data?.vendors || [],
        isLoading,
        error,
        refetch,
    }
}
